import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: number): string {
  return new Intl.NumberFormat('ar-IQ', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPriceWithCurrency(amount: number): string {
  return `${formatPrice(amount)} د.ع`;
}

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('ar-IQ', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);
}

export function formatRelativeTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'الآن';
  if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
  if (diffHours < 24) return `منذ ${diffHours} ساعة`;
  if (diffDays < 7) return `منذ ${diffDays} يوم`;
  return formatDate(d);
}

export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('ar-IQ', { hour: '2-digit', minute: '2-digit' });
}

export function isValidIraqiPhone(phone: string): boolean {
  const phoneRegex = /^(\+964|0)?7[0-9]{9}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
}

export function formatIraqiPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('964')) {
    return `+964 ${digits.slice(3, 6)} ${digits.slice(6, 9)} ${digits.slice(9)}`;
  }
  if (digits.startsWith('0')) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  }
  return phone;
}

export const VEHICLE_LABELS: Record<string, { en: string; ar: string }> = {
  sedan: { en: 'Sedan', ar: 'سيدان' },
  suv: { en: 'SUV', ar: 'دفع رباعي' },
  large_suv: { en: 'Large SUV', ar: 'دفع رباعي كبير' },
};

export const QUEUE_STATUS_LABELS: Record<string, { ar: string; color: string }> = {
  waiting: { ar: 'بالانتظار', color: 'text-amber-600 bg-amber-100' },
  washing: { ar: 'يُغسل', color: 'text-blue-600 bg-blue-100' },
  ready: { ar: 'جاهز', color: 'text-green-600 bg-green-100' },
  completed: { ar: 'مكتمل', color: 'text-gray-600 bg-gray-100' },
  cancelled: { ar: 'ملغي', color: 'text-red-600 bg-red-100' },
};
